import clsx from "clsx";
import { Box, Button, ButtonColors } from "@talentech/components";

interface ToggleButtonGroupProps<T extends string> {
  ariaLabel: string;
  options: { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
}

const ToggleButtonGroup = <T extends string>({
  ariaLabel,
  options,
  value,
  onChange,
  className,
}: ToggleButtonGroupProps<T>) => (
  <Box
    className={clsx("btn-group toggle-button-group", className)}
    role="group"
    aria-label={ariaLabel}
  >
    {options.map((option) => (
      <Button
        key={option.value}
        label={option.label}
        color={ButtonColors.PRIMARY}
        outline
        active={value === option.value}
        aria-pressed={value === option.value}
        onClick={() => onChange(option.value)}
      />
    ))}
  </Box>
);

export default ToggleButtonGroup;
